var _desc, _rect, _text, _text2, _rect2, _text3, _rect3, _text4, _rect4, _text5, _rect5, _text6, _rect6, _text7, _g, _g2, _g3, _g4, _g5, _text8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 560 384",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    fontFamily: "Inter, system-ui, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustrated view of the Kawnter transactions screen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A transaction log with search, action and date filters, listing product updates, stock additions and completed orders, each naming the staff member and the time it happened.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 384,
    rx: 10,
    fill: "#F4F7F8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 26,
    fontSize: 12.5,
    fontWeight: 700,
    fill: "#14344B"
  }, "Transactions")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 26,
    fontSize: 9,
    fill: "#8AA0AE"
  }, "Registrations, changes and orders \u2014 tap a record for detail")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 176,
    height: 30,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 23,
    y: 57,
    fontSize: 9,
    fill: "#9BAFBC"
  }, "Product, category, staff\u2026")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 38,
    width: 112,
    height: 30,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 209,
    y: 57,
    fontSize: 9,
    fill: "#9BAFBC"
  }, "All actions")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 38,
    width: 102,
    height: 30,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 331,
    y: 57,
    fontSize: 9,
    fill: "#9BAFBC"
  }, "16 Sep 2026")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 38,
    width: 102,
    height: 30,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 443,
    y: 57,
    fontSize: 9,
    fill: "#9BAFBC"
  }, "25 Sep 2026")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 38,
    width: 44,
    height: 30,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 566,
    y: 57,
    fontSize: 9,
    fontWeight: 600,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Clear")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,80)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 536,
    height: 52,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9 a9 9 0 0 1 3 -8 v50 a9 9 0 0 1 -3 -8z",
    fill: "#C87F4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1,
    width: 3.5,
    height: 50,
    fill: "#C87F4A"
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 20,
    fontSize: 11,
    fontWeight: 700,
    fill: "#14344B"
  }, "Product updated"), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 33,
    fontSize: 8.5,
    fill: "#8AA0AE"
  }, "Maricel"), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 20,
    fontSize: 8.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "25 Sep 2026, 6:02 PM"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37,
    width: 90,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "category"), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "Drinks"), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 37,
    width: 97,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "name"), /*#__PURE__*/React.createElement("text", {
    x: 141,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "Iced matcha"), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 37,
    width: 59,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 223,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "price"), /*#__PURE__*/React.createElement("text", {
    x: 249,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "120"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,140)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 536,
    height: 52,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9 a9 9 0 0 1 3 -8 v50 a9 9 0 0 1 -3 -8z",
    fill: "#2E9B9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1,
    width: 3.5,
    height: 50,
    fill: "#2E9B9B"
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 20,
    fontSize: 11,
    fontWeight: 700,
    fill: "#14344B"
  }, "Stock added"), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 33,
    fontSize: 8.5,
    fill: "#8AA0AE"
  }, "Maricel"), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 20,
    fontSize: 8.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "25 Sep 2026, 6:00 PM"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37,
    width: 53,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "added"), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "24"), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 37,
    width: 58,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 83,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "before"), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "22"), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 37,
    width: 53,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 148,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "after"), /*#__PURE__*/React.createElement("text", {
    x: 174,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "46"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,200)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 536,
    height: 52,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9 a9 9 0 0 1 3 -8 v50 a9 9 0 0 1 -3 -8z",
    fill: "#4E9A92"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1,
    width: 3.5,
    height: 50,
    fill: "#4E9A92"
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 20,
    fontSize: 11,
    fontWeight: 700,
    fill: "#14344B"
  }, "Order completed"), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 33,
    fontSize: 8.5,
    fill: "#8AA0AE"
  }, "Jomar"), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 20,
    fontSize: 8.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "25 Sep 2026, 5:47 PM"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37,
    width: 64,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "total"), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "\u20B1240"), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 37,
    width: 65,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "paid"), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "GCash"), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 37,
    width: 48,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 165,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "items"), /*#__PURE__*/React.createElement("text", {
    x: 191,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "2"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,260)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 536,
    height: 52,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9 a9 9 0 0 1 3 -8 v50 a9 9 0 0 1 -3 -8z",
    fill: "#C87F4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1,
    width: 3.5,
    height: 50,
    fill: "#C87F4A"
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 20,
    fontSize: 11,
    fontWeight: 700,
    fill: "#14344B"
  }, "Product updated"), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 33,
    fontSize: 8.5,
    fill: "#8AA0AE"
  }, "Owner"), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 20,
    fontSize: 8.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "25 Sep 2026, 5:31 PM"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37,
    width: 84,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "category"), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "Foods"), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 37,
    width: 113,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 114,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "name"), /*#__PURE__*/React.createElement("text", {
    x: 136,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "Breakfast meal"), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 37,
    width: 59,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 233,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "price"), /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "150"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,320)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 536,
    height: 52,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9 a9 9 0 0 1 3 -8 v50 a9 9 0 0 1 -3 -8z",
    fill: "#2E9B9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1,
    width: 3.5,
    height: 50,
    fill: "#2E9B9B"
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 20,
    fontSize: 11,
    fontWeight: 700,
    fill: "#14344B"
  }, "Stock added"), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 33,
    fontSize: 8.5,
    fill: "#8AA0AE"
  }, "Jomar"), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 20,
    fontSize: 8.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "25 Sep 2026, 5:14 PM"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37,
    width: 53,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "added"), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "12"), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 37,
    width: 53,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 83,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "before"), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "0"), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 37,
    width: 53,
    height: 12,
    rx: 6,
    fill: "#F4F7F8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 142,
    y: 46,
    fontSize: 7.5,
    fill: "#8AA0AE"
  }, "after"), /*#__PURE__*/React.createElement("text", {
    x: 169,
    y: 46,
    fontSize: 7.5,
    fontWeight: 700,
    fill: "#237C7C"
  }, "12"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 378,
    fontSize: 8.5,
    fill: "#8AA0AE"
  }, "Showing 1\u20135 of 90")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.b76a835888b854820be8a104681e08bb.svg";
export { ForwardRef as ReactComponent };